'use strict';

var $ = require('jquery');

function AnchorLinkSmoothScroll(selector) {
	var $scrollBtnEl = $(selector);

	if (!$scrollBtnEl.length) {
		return;
	}

	$scrollBtnEl.on('click.scrollTo', function(event) {
		var targetId = $(this).attr('href').match(/#.*/)[0];
		
		$('html, body').animate({
			scrollTop: $(targetId).offset().top - 30 },
			'slow');
	});
}

module.exports = {
	init: function(){
		AnchorLinkSmoothScroll('a.smoothScroll');
	}
};

